/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_VimeoInputs */



/**
* | output |
* | --- |
* | "Vimeo" |
*
* @param {Media_Import_Source_VimeoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_vimeo = /** @type {((inputs?: Media_Import_Source_VimeoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_VimeoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vimeo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vimeo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vimeo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Vimeo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vimeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Vimeo")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ヴィメオ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विमियो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vimeo")
	return /** @type {LocalizedString} */ ("Vimeo")
});